module.exports = __webpack_public_path__ + "static/media/clock-white.13817d16.svg";